import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, Panel, Format, Text } from 'src/Components'
import FormField from 'src/Components/FormField'

import styles from '../EditBalance.module.scss'

const EditBalanceForm = ({
  estimatedValue,
  onSubmit,
  onChangeValue,
  onCancel,
  saving,
  loanAmount
}) => (
  <form className={styles.form} onSubmit={onSubmit}>
    <Panel.Heading>
      <FormattedMessage
        id='Mortgages.editBalance.heading'
        defaultMessage='Update your loan balance'
      />
    </Panel.Heading>

    <Text align='center' size='l' className={styles.estimatedValueHeading}>
      <FormattedMessage
        id='Mortgages.editBalance.valueHeading'
        defaultMessage="We've estimated your balance is {balance}"
        values={{
          balance: <Format.Currency value={estimatedValue} format='0,0' />
        }}
      />
    </Text>

    <div className={styles.subheading}>
      <FormattedMessage
        id='Mortgages.editBalance.subheading'
        defaultMessage='We calculate all of your numbers based on loan details, today’s balance, and extra monthly principal payments.'
      />
    </div>

    <div className={styles.formFields}>
      <FormField
        className={styles.input}
        required
        type='number'
        name='balance'
        max={loanAmount}
        min='0'
        step='1'
        placeholder='$0'
        defaultValue={Math.round(estimatedValue)}
        onChange={onChangeValue}
        captionMessage={
          <FormattedMessage
            id='Mortgages.editBalance.assumption'
            defaultMessage="Assuming you've paid this month's bill"
          />
        }
        data-qa='EditBalanceFormField'
      >
        <FormattedMessage
          id='Mortgages.editBalance.todayBalance'
          defaultMessage="Today's balance"
        />
      </FormField>
    </div>

    <Button.Group className={styles.buttonGroup}>
      <Button
        primary
        disabled={saving}
        loading={saving}
        type='submit'
        data-qa='EditBalanceSaveButton'
      >
        <FormattedMessage
          id='Mortgages.editBalance.saveButton'
          defaultMessage='Save changes'
        />
      </Button>
      <Button
        minimal
        disabled={saving}
        onClick={onCancel}
        data-qa='EditBalanceCancelButton'
      >
        <FormattedMessage
          id='Mortgages.editBalance.cancelButton'
          defaultMessage='Cancel'
        />
      </Button>
    </Button.Group>
  </form>
)

export default EditBalanceForm
